import type { ExtensionState, WsConnectionState } from '@hit/react-jssip';
import * as Sentry from '@sentry/react';

export type CallAnswerFailureParams = {
  type: 'unanswerable_state' | 'answer_throw' | 'answer_timeout';
  callId: string;
  jssipSessionStatus: number;
  wsConnectionState: WsConnectionState;
  extensionState: ExtensionState;
  error?: unknown;
};

export const reportCallAnswerFailure = (params: CallAnswerFailureParams) => {
  const error = params.error;
  Sentry.withScope((scope) => {
    scope.setLevel('error');

    scope.setTag('feature', 'call_answer');
    scope.setTag('failure_type', params.type);
    scope.setTag('jssip_session_status', params.jssipSessionStatus);
    scope.setTag('call_id', params.callId);

    scope.setContext('ws_connection', {
      state: params.wsConnectionState,
    });
    scope.setContext('extension', {
      state: params.extensionState,
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const connection = (navigator as any).connection;
    if (connection) {
      scope.setContext('connectivity', {
        onLine: navigator.onLine,
        type: connection.type,
        effectiveType: connection.effectiveType,
        rtt: connection.rtt,
        downlink: connection.downlink,
      });
    }

    scope.setFingerprint(['call_answer', params.type]);

    const message = 'hitphone.call_answer_failed';

    if (error) {
      Sentry.captureException(error);
    } else {
      Sentry.captureMessage(message);
    }
  });
};
